import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../model/rootReducer'
import GraphGenerationForm from './generationForms/GraphGenerationForm'
import ActionsForm from './actionsForm/ActionsForm'

type FormProps = {
  generateGraph: (selectedFilters: Object) => void
  updateGraph: () => void
  selectedActions: string[]
}

const GraphForms: React.FunctionComponent<FormProps> = ({
  generateGraph,
  updateGraph,
  selectedActions,
}) => {
  const graphData = useSelector(
    (state: RootState) => state.monitoringGraph.graph
  )

  return (
    <>
      <GraphGenerationForm generateGraph={generateGraph}></GraphGenerationForm>
      {graphData.availableActions.length > 0 && (
        <ActionsForm
          updateGraph={updateGraph}
          actions={graphData}
          selectedActions={selectedActions}
        ></ActionsForm>
      )}
    </>
  )
}
export default GraphForms
